import React from "react";

import { getLocaleValue } from "../../../helpers/get-locale-value";
import { Box, Typography } from "@material-ui/core";
import Navigation from "../../shared-components/navigation";

const NewsCategoryListItemViewTablet = ({
  locale,
  data,
  location,
  currentNewsCategory,
}) => {
  const { variants, id, slug } = data;
  const category = getLocaleValue(locale, variants);
  const newsCategory = currentNewsCategory
    ? getLocaleValue(locale, currentNewsCategory.variants)
    : null;

  const isActive =
    location.pathname === `/news/${slug}` ||
    (newsCategory && category.content == newsCategory.content);

  return (
    <Navigation to={`/news/${slug}`}>
      <Box
        display="inline-block"
        py={1}
        px={2}
        className={`${isActive ? "text-active" : ""}`}
      >
        <Typography variant="h6">{category.content}</Typography>
      </Box>
    </Navigation>
  );
};
export default NewsCategoryListItemViewTablet;
